export const INTEGRATION_REDIRECT = '/redirect/:integrationType'

const integrationRedirectRoutes = [INTEGRATION_REDIRECT]

export default integrationRedirectRoutes
